(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[68021],{

/***/ 95414:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/our-values",
      function () {
        return __webpack_require__(40117);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ SeveralBrandsHome; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/severalBrandsWrapper.tsx + 9 modules
var severalBrandsWrapper = __webpack_require__(73191);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 111 modules
var motion = __webpack_require__(76265);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/firstSection/index.tsx



const list = [
    {
        title: "Mutual Success",
        p: "When your company grows, so do we. Our performance-based model means we're only invested in delivering real opportunities, not just activity, so your goals and ours stay aligned."
    },
    {
        title: "Transparency",
        p: "Transparency runs both ways for us. Regular check-ins and open communication help us adapt campaigns to your needs, rather than a one-size-fits-all approach delivered and forgotten."
    },
    {
        title: "Delivering on Our Promises",
        p: "You only pay for leads that have cleared our verification for fraud and intent, no hidden costs, no empty promises. If a lead doesn't fit, we make it right."
    },
    {
        title: "Long-Term Relationships",
        p: "We're not chasing one-off campaigns. We listen, adapt, and refine your lead strategy over time, prioritizing lasting partnerships over short-term wins."
    },
    {
        title: "Serving a Diverse Audience",
        p: "We reach U.S. audiences in the languages they speak, translating campaigns to connect with non-English-speaking residents alongside English-speaking ones."
    }, 
];
function FirstSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "lg:mt-28 mt-14 px-4 lg:px-0 lg:mb-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                transition: {
                    duration: 1.5
                },
                initial: {
                    opacity: 0,
                    y: 150
                },
                whileInView: {
                    opacity: 1,
                    y: 0
                },
                viewport: {
                    once: true
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "font-bold text-[#351C4F] 3xl:text-8xl 3xl:leading-[5.5rem] lg:text-6xl lg:leading-[4.5rem] text-4xl leading-10 text-center",
                        children: "Lead Generation Built on Values"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "lg:mt-7 mt-4 3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 3xl:max-w-[1053px] max-w-[853px] mx-auto text-center font-light",
                        children: "We grow when you grow. Several Brands' values, transparency, mutual success, and long-term partnerships, are built around performance-based lead generation."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.section */.E.section, {
                transition: {
                    duration: 1.5
                },
                initial: {
                    opacity: 0,
                    y: 150
                },
                whileInView: {
                    opacity: 1,
                    y: 0
                },
                viewport: {
                    once: true
                },
                className: `flex flex-col lg:flex-row   mt-10 lg:mt-16   3xl:gap-[200px] lg:gap-[150px] gap-[30px]`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ` mx-auto lg:mx-0   order-1 lg:order-1 w-[300px]  h-[250px] md:w-[548px] md:min-w-[548px] md:h-[770px] 3xl:w-[648px] 3xl:min-w-[648px] 3xl:h-[870px] relative`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/severalbrands/assets/images/ourValuesImg2.png",
                            alt: "img",
                            layout: "fill",
                            objectFit: "contain"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ` 3xl:max-w-[800px] max-w-[600px] mx-auto lg:mx-0 order-2 lg:order-2`,
                        children: list.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-8 first-of-type:mt-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: `font-bold 3xl:text-4xl leading-[3rem] lg:text-2xl text-lg lg:leading-9 text-[#351C4F]  `,
                                        children: el.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: `mt-2 3xl:text-2xl 3xl:leading-10 lg:text-lg  text-base lg:leading-8  font-light`,
                                        children: el.p
                                    }, index)
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/style.module.scss
var style_module = __webpack_require__(96494);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/sharedMainComponent/index.tsx



function MainSharedComponent({ title , description , htmlDescription , icon  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.li */.E.li, {
        transition: {
            duration: 1.5
        },
        initial: {
            opacity: 0,
            y: 150
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        viewport: {
            once: true
        },
        className: ` 3xl:w-[700px] lg:w-[500px] `,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-[#37367D] 3xl:text-4xl 3xl:leading-[3.5rem] text-lg lg:text-2xl lg:leading-10 mt-7 font-bold",
                children: title
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 mt-5 font-light",
                children: description
            }),
            htmlDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 mt-5 font-light",
                children: htmlDescription
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/expertsMultipleMarketsIcon.tsx


function ExpertsMultipleMarketsIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M17.351 26.545l3.533 1.465a20.4 20.4 0 00-.95 3.097l-.134.61 5.064 5.066.609-.13a20.414 20.414 0 003.097-.95l1.465 3.532a.228.228 0 00.374.073l2.214-2.214a3.654 3.654 0 001.066-2.768l-.079-1.422c4.099-3.027 8.247-8.335 9.377-17.599a1.523 1.523 0 00-1.709-1.718c-9.26 1.14-14.572 5.29-17.599 9.377l-1.419-.073a3.655 3.655 0 00-2.768 1.05l-2.214 2.214a.229.229 0 00.073.39zm14.204-5.396a2.741 2.741 0 113.87 3.883 2.741 2.741 0 01-3.87-3.883zM16.69 37.189a3.597 3.597 0 00-1.827-.147.33.33 0 01-.304-.091.332.332 0 01-.067-.375c.648-1.394 2.369-4.199 5.484-1.933a.154.154 0 01.038.179.155.155 0 01-.038.052 3.384 3.384 0 00-1.288 2.771.247.247 0 00.238.238 3.38 3.38 0 002.77-1.26.156.156 0 01.188-.043c.02.01.039.024.053.042.433.515 1.623 2.196.305 3.819a3.426 3.426 0 01-2.296 1.218c-1.28.137-3.642.554-4.608 1.657a.332.332 0 01-.572-.122c-.341-1.163-.871-3.764 1.924-6.006z"
            })
        ]
    });
}
/* harmony default export */ var expertsMultipleMarketsIcon = (ExpertsMultipleMarketsIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/speakSeveralLanguagesIcon.tsx


function SpeakSeveralLanguagesIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M28.5 45c-1.938 0-3.956-2.662-5.157-7.1a35.45 35.45 0 0110.314 0c-1.2 4.438-3.22 7.1-5.157 7.1zm0-8.972a36.322 36.322 0 00-5.505.413 35.636 35.636 0 01-.725-6.693h12.46a35.636 35.636 0 01-.725 6.693 36.322 36.322 0 00-5.505-.413zM13 29.748h7.82c.03 2.336.284 4.664.754 6.95a22.61 22.61 0 00-5.54 1.794A16.222 16.222 0 0113 29.748zm3.034-10.264a22.61 22.61 0 005.54 1.794 36.96 36.96 0 00-.754 6.95H13a16.222 16.222 0 013.034-8.744zM28.5 13c1.938 0 3.956 2.662 5.157 7.1a34.903 34.903 0 01-5.157.377 34.903 34.903 0 01-5.157-.377c1.2-4.438 3.22-7.1 5.157-7.1zm0 8.972a36.322 36.322 0 005.505-.413c.452 2.202.695 4.443.725 6.693H22.27c.03-2.25.273-4.491.725-6.693 1.823.277 3.663.415 5.505.413zm15.5 6.28h-7.82a36.958 36.958 0 00-.754-6.95 22.61 22.61 0 005.54-1.794A16.222 16.222 0 0144 28.252zm-7.82 1.496H44a16.224 16.224 0 01-3.034 8.768 22.61 22.61 0 00-5.54-1.794 36.96 36.96 0 00.754-6.974zm3.84-11.454a22.196 22.196 0 01-4.936 1.555 16.359 16.359 0 00-3.028-6.4 15.4 15.4 0 017.965 4.845zm-15.076-4.845a16.359 16.359 0 00-3.028 6.4 22.196 22.196 0 01-4.937-1.555 15.4 15.4 0 017.965-4.845zm-7.965 26.258a22.196 22.196 0 014.937-1.556 16.359 16.359 0 003.028 6.4 15.4 15.4 0 01-7.965-4.845zm15.083 4.862a16.362 16.362 0 003.022-6.418c1.697.323 3.354.845 4.937 1.555a15.4 15.4 0 01-7.965 4.845l.006.018z"
            })
        ]
    });
}
/* harmony default export */ var speakSeveralLanguagesIcon = (SpeakSeveralLanguagesIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/collaborationIcon.tsx


function CollaborationIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M35.002 29.6a6.401 6.401 0 00-6.4 6.4v7.357c0 .353.283.643.642.643H40.76a.641.641 0 00.643-.643V36c0-3.534-2.867-6.4-6.4-6.4zM35.003 26.4a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6zM22.2 24.8a6.401 6.401 0 00-6.4 6.4v7.357c0 .353.284.643.643.643h8.315a.641.641 0 00.643-.643V36a9.56 9.56 0 012.564-6.52.629.629 0 00.138-.668c-.945-2.35-3.219-4.012-5.902-4.012zM22.202 21.6a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6z"
            })
        ]
    });
}
/* harmony default export */ var collaborationIcon = (CollaborationIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/flexibilityIcon.tsx


function FlexibilityIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M40.61 38.553H16.608a1.44 1.44 0 000 2.879H40.61a1.44 1.44 0 000-2.88zM16.41 31.44l12.04 2.3a1.424 1.424 0 00.354-.005l11.982-2.29a1.434 1.434 0 10-.374-2.845c-.062.004-11.764 2.283-11.819 2.27l-11.828-2.274a1.442 1.442 0 00-1.593 1.425 1.42 1.42 0 001.238 1.42z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M40.45 33.395l-11.79 1.31a.389.389 0 01-.105 0l-11.79-1.31a1.434 1.434 0 00-.317 2.85l12.001 1.334c.105.012.211.012.317 0l12-1.334a1.434 1.434 0 00-.316-2.85zM28.244 28.788a.48.48 0 00.73 0l2.878-3.36a.483.483 0 00-.364-.79h-.96V16.96a.963.963 0 00-.96-.96H27.65a.963.963 0 00-.96.96v7.677h-.96a.484.484 0 00-.364.792l2.879 3.359z"
            })
        ]
    });
}
/* harmony default export */ var flexibilityIcon = (FlexibilityIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/severalDigitalMarketingIcon.tsx


function SeveralDigitalMarketingIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M36.868 20.136c-.846-2.802-1.953-4.191-3.313-4.134-.423.021-.818.189-1.176.499l-13.364 7.207-3.824.194c-1.488.075-2.716.945-3.46 2.451-1.093 2.218-.946 5.465.343 7.552.83 1.348 2.064 2.09 3.472 2.09.068 0 .137-.002.207-.005l.21-.011 1.061 4.158c.136.53.57.88 1.366 1.103.186.052.682.174 1.255.174.772 0 1.373-.217 1.784-.645.275-.285.695-.921.426-1.974l-.584-2.29 12.406 5.2a1.872 1.872 0 001.088.293c1.35-.069 2.33-1.566 2.914-4.45.48-2.367.66-5.475.508-8.752-.153-3.275-.621-6.35-1.319-8.66zm-1.665 8.409c-.056-1.198-.472-2.315-1.171-3.146-.504-.599-1.124-1.012-1.801-1.2.274-3.834 1.034-5.766 1.425-6.04.646.35 2.175 4.193 2.48 10.74.303 6.535-.872 10.588-1.46 10.948-.47-.222-1.518-2.52-2.111-6.646 1.634-.594 2.736-2.527 2.638-4.656zm9.583 5.41a.88.88 0 01-.051.65.811.811 0 01-.728.462.794.794 0 01-.373-.094l-2.809-1.508a.839.839 0 01-.404-.498.88.88 0 01.052-.65.803.803 0 011.1-.369l2.809 1.508a.843.843 0 01.404.498zm-3.952-8.274a.807.807 0 01-.688-.391.876.876 0 01.245-1.179l2.655-1.783a.799.799 0 011.13.255.877.877 0 01-.245 1.18l-2.655 1.783a.798.798 0 01-.442.135zm5.165 2.835c.022.47-.327.87-.777.893l-3.195.16c-.436 0-.795-.356-.816-.81a.87.87 0 01.212-.615.798.798 0 01.566-.279l3.154-.16a.836.836 0 01.856.81z"
            })
        ]
    });
}
/* harmony default export */ var severalDigitalMarketingIcon = (SeveralDigitalMarketingIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/accountBasedMarketingIcon.tsx


function AccountBasedMarketingIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M43.21 16.194l-2.7 2.63a.574.574 0 01-.401.16h-.07l-.252-.034-1.343-.149-2.676 2.814-2.389 2.504-.792.826-1.574 1.666-.804.838-1.596 1.677-1.94 2.032a.59.59 0 01-.426.173.569.569 0 01-.413-.965l1.94-2.033 1.597-1.676.804-.839 1.585-1.665.792-.838 2.389-2.493 2.607-2.733-.138-1.435-.034-.39a.603.603 0 01.172-.472l2.699-2.63a.569.569 0 01.964.356l.138 1.516 1.516.173a.569.569 0 01.482.39.603.603 0 01-.137.597zm-9.084 8.809a9.756 9.756 0 11-7.879-4.008 9.613 9.613 0 015.386 1.63l2.4-2.526a13.089 13.089 0 00-7.786-2.55 13.227 13.227 0 1010.279 4.927l-2.4 2.527zm-3.308-1.54a8.513 8.513 0 00-4.57-1.32 8.613 8.613 0 108.613 8.613 8.514 8.514 0 00-1.54-4.903l-1.63 1.71c.578.965.88 2.07.873 3.193a6.316 6.316 0 11-6.317-6.316 6.165 6.165 0 012.94.735l1.631-1.711zm-4.57 4.422c.114 0 .229.012.344.023l1.78-1.86a5.167 5.167 0 103.043 4.709 4.993 4.993 0 00-.563-2.332l-1.768 1.872c.023.152.035.306.034.46a2.87 2.87 0 11-2.87-2.872z"
            })
        ]
    });
}
/* harmony default export */ var accountBasedMarketingIcon = (AccountBasedMarketingIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/performanceBasedPricingModelIcon.tsx


function PerformanceBasedPricingModelIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M20.422 45L12 38.128l4.828-4.745a9.324 9.324 0 0110.002-2.016h5.943c.591 0 1.158.234 1.577.651a2.221 2.221 0 010 3.146 2.233 2.233 0 01-1.577.652H28.17a.739.739 0 00-.738.736.735.735 0 00.738.736h5.215a2.633 2.633 0 001.964-.88l5.622-6.396a2.317 2.317 0 014.022 1.389 2.305 2.305 0 01-.548 1.662l-7.02 8.153a5.508 5.508 0 01-4.151 1.882h-10.96L20.423 45zm3.403-22.394a1.157 1.157 0 00-1.152 1.149v3.972a1.151 1.151 0 001.152 1.15h2.56a1.157 1.157 0 001.152-1.15v-3.969a1.151 1.151 0 00-1.152-1.149l-2.56-.003zm13.105 6.27h2.56a1.157 1.157 0 001.146-1.149v-7.729a1.15 1.15 0 00-1.153-1.15H36.93a1.157 1.157 0 00-1.152 1.15v7.73a1.152 1.152 0 001.152 1.148zM29.225 13.15v14.578a1.151 1.151 0 001.152 1.15h2.56a1.157 1.157 0 001.153-1.15V13.15A1.15 1.15 0 0032.94 12h-2.56a1.157 1.157 0 00-1.156 1.15z"
            })
        ]
    });
}
/* harmony default export */ var performanceBasedPricingModelIcon = (PerformanceBasedPricingModelIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/dedicatedAccountManagerIcon.tsx


function DedicatedAccountManagerIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M42.935 35.268l-2.09-7.502c.57-7.218-5.27-13.961-13.01-13.961-11.634 0-17.475 14.15-9.213 22.318l.048 7.598c0 .237.19.475.475.475h15.48c.285 0 .475-.19.475-.475v-2.137h2.422c1.092 0 2.042-.902 2.042-2.042V37.69h1.567c1.187 0 2.136-1.187 1.804-2.422zm-6.126-6.933c0 .238-.19.428-.427.428l-2.09.19c-.094.19-.19.38-.237.522l1.14 1.757c.142.19.095.427-.095.617l-1.995 1.852c-.19.143-.427.19-.617.048l-1.662-1.235c-.19.095-.38.143-.57.238l-.38 1.947a.462.462 0 01-.474.38h-2.707a.462.462 0 01-.475-.38l-.38-2.042c-.522-.19-1.044-.428-1.52-.76l-1.851.95a.518.518 0 01-.618-.143l-1.662-2.137a.5.5 0 010-.617l1.378-1.567c-.048-.19-.143-.38-.19-.57l-1.995-.522c-.237-.048-.38-.285-.332-.475l.237-2.707c0-.237.19-.427.428-.427l2.089-.19c.095-.19.19-.38.285-.523l-1.14-1.757c-.142-.19-.095-.427.095-.617l1.994-1.852c.19-.142.428-.19.618-.047l1.662 1.234c.19-.095.38-.142.57-.237l.38-2.042a.462.462 0 01.474-.38h2.707c.238 0 .427.143.475.38l.38 2.042c.522.19 1.045.427 1.52.76l1.851-.95a.518.518 0 01.618.142l1.662 2.137a.5.5 0 010 .618l-1.377 1.567c.047.19.142.38.19.57l1.994.522c.237.047.38.285.332.475l-.285 2.801z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M28.072 23.396c-1.567 0-2.896 1.283-2.896 2.897 0 1.567 1.282 2.897 2.896 2.897 1.568 0 2.897-1.282 2.897-2.897 0-1.614-1.33-2.896-2.897-2.896z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M33.772 25.106c-.047-.333-.19-.665-.285-.997-.047-.19-.047-.38.096-.475l1.33-1.472-1.188-1.52-1.757.902c-.142.095-.332.095-.522-.047a6.035 6.035 0 00-1.757-.855c-.19-.047-.285-.19-.333-.38l-.332-1.947h-1.9l-.332 1.947c-.048.19-.143.333-.332.38-.333.095-.618.19-.95.38-.143.095-.333.048-.523-.047l-1.566-1.188-1.378 1.283 1.045 1.662c.095.142.095.332 0 .522-.19.285-.332.617-.427.902-.048.19-.238.285-.38.285l-1.947.19-.143 1.9 1.9.522c.19.047.285.19.332.38.048.332.19.665.285.997.048.19.048.38-.095.475l-1.33 1.472 1.188 1.52 1.757-.903c.142-.095.332-.047.522.048a6.03 6.03 0 001.757.854c.19.048.285.19.332.38l.333 1.947h1.9l.332-1.947c.047-.19.142-.332.332-.38.332-.095.665-.19.95-.38.142-.094.332-.047.522.048l1.567 1.187 1.377-1.282-1.044-1.662c-.095-.142-.095-.332 0-.522.19-.285.332-.618.427-.902.048-.19.237-.285.38-.285l1.947-.19.142-1.9-1.9-.522c-.142-.095-.284-.238-.332-.38zm-5.698 4.986c-2.09 0-3.846-1.71-3.846-3.846 0-2.09 1.71-3.847 3.846-3.847a3.83 3.83 0 013.846 3.847c0 2.137-1.757 3.846-3.846 3.846z"
            })
        ]
    });
}
/* harmony default export */ var dedicatedAccountManagerIcon = (DedicatedAccountManagerIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/cuttingEdgeTechnologyIcon.tsx


function CuttingEdgeTechnologyIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M34.688 18.531H22.312a3.77 3.77 0 00-3.78 3.782v12.375a3.77 3.77 0 003.78 3.78h12.375a3.77 3.77 0 003.782-3.78V22.312a3.77 3.77 0 00-3.782-3.78zM28.5 32.97a4.46 4.46 0 01-4.469-4.469 4.46 4.46 0 014.469-4.469 4.46 4.46 0 014.469 4.469 4.46 4.46 0 01-4.469 4.469zM26.438 17.156c.584 0 1.03-.447 1.03-1.031v-3.094c0-.584-.446-1.031-1.03-1.031-.585 0-1.032.447-1.032 1.031v3.094c0 .584.447 1.031 1.032 1.031zM30.563 17.156c.584 0 1.03-.447 1.03-1.031v-3.094c0-.584-.446-1.031-1.03-1.031-.585 0-1.032.447-1.032 1.031v3.094c0 .584.447 1.031 1.032 1.031zM22.313 17.156c.584 0 1.03-.447 1.03-1.031v-3.094c0-.584-.446-1.031-1.03-1.031-.585 0-1.032.447-1.032 1.031v3.094c0 .584.447 1.031 1.032 1.031zM34.688 17.156c.584 0 1.03-.447 1.03-1.031v-3.094c0-.584-.446-1.031-1.03-1.031-.585 0-1.032.447-1.032 1.031v3.094c0 .584.447 1.031 1.032 1.031zM26.438 39.844c-.585 0-1.032.447-1.032 1.031v3.094c0 .584.447 1.031 1.032 1.031.584 0 1.03-.447 1.03-1.031v-3.094c0-.584-.446-1.031-1.03-1.031zM30.563 39.844c-.585 0-1.032.447-1.032 1.031v3.094c0 .584.447 1.031 1.032 1.031.584 0 1.03-.447 1.03-1.031v-3.094c0-.584-.446-1.031-1.03-1.031zM22.313 39.844c-.585 0-1.032.447-1.032 1.031v3.094c0 .584.447 1.031 1.032 1.031.584 0 1.03-.447 1.03-1.031v-3.094c0-.584-.446-1.031-1.03-1.031zM34.688 39.844c-.585 0-1.032.447-1.032 1.031v3.094c0 .584.447 1.031 1.032 1.031.584 0 1.03-.447 1.03-1.031v-3.094c0-.584-.446-1.031-1.03-1.031zM43.969 25.406h-3.094c-.584 0-1.031.447-1.031 1.032 0 .584.447 1.03 1.031 1.03h3.094c.584 0 1.031-.446 1.031-1.03 0-.585-.447-1.032-1.031-1.032zM43.969 29.531h-3.094c-.584 0-1.031.447-1.031 1.032 0 .584.447 1.03 1.031 1.03h3.094c.584 0 1.031-.446 1.031-1.03 0-.585-.447-1.032-1.031-1.032zM40.875 23.344h3.094c.584 0 1.031-.447 1.031-1.032 0-.584-.447-1.03-1.031-1.03h-3.094c-.584 0-1.031.446-1.031 1.03 0 .585.447 1.032 1.031 1.032zM43.969 33.656h-3.094c-.584 0-1.031.447-1.031 1.032 0 .584.447 1.03 1.031 1.03h3.094c.584 0 1.031-.446 1.031-1.03 0-.585-.447-1.032-1.031-1.032zM16.125 25.406h-3.094c-.584 0-1.031.447-1.031 1.032 0 .584.447 1.03 1.031 1.03h3.094c.584 0 1.031-.446 1.031-1.03 0-.585-.447-1.032-1.031-1.032zM16.125 29.531h-3.094c-.584 0-1.031.447-1.031 1.032 0 .584.447 1.03 1.031 1.03h3.094c.584 0 1.031-.446 1.031-1.03 0-.585-.447-1.032-1.031-1.032zM16.125 21.281h-3.094c-.584 0-1.031.447-1.031 1.032 0 .584.447 1.03 1.031 1.03h3.094c.584 0 1.031-.446 1.031-1.03 0-.585-.447-1.032-1.031-1.032zM16.125 33.656h-3.094c-.584 0-1.031.447-1.031 1.032 0 .584.447 1.03 1.031 1.03h3.094c.584 0 1.031-.446 1.031-1.03 0-.585-.447-1.032-1.031-1.032z"
            })
        ]
    });
}
/* harmony default export */ var cuttingEdgeTechnologyIcon = (CuttingEdgeTechnologyIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/filtersQualifyLeadsIcon.tsx


function FiltersQualifyLeadsIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M29 20.951c-4.438 0-8.049 3.61-8.049 8.049 0 4.438 3.61 8.049 8.049 8.049 4.438 0 8.049-3.61 8.049-8.049 0-4.438-3.61-8.049-8.049-8.049zm4.176 6.371l-4.39 4.39a.728.728 0 01-1.035 0l-2.927-2.926a.732.732 0 111.035-1.035l2.41 2.41 3.872-3.873a.732.732 0 111.035 1.034zm10.656 1.212l-2.373-2.872.62-3.674a.732.732 0 00-.467-.808l-3.491-1.3-1.301-3.492a.73.73 0 00-.808-.466l-3.674.62-2.872-2.374a.732.732 0 00-.932 0l-2.872 2.373-3.674-.62a.73.73 0 00-.808.467l-1.3 3.491-3.492 1.301a.732.732 0 00-.466.808l.62 3.674-2.374 2.872a.732.732 0 000 .932l2.373 2.872-.62 3.674a.732.732 0 00.467.808l3.491 1.3 1.301 3.492a.73.73 0 00.808.466l3.674-.62 2.872 2.374a.732.732 0 00.932 0l2.872-2.373 3.674.62a.731.731 0 00.808-.467l1.3-3.492 3.492-1.3a.731.731 0 00.466-.808l-.62-3.674 2.374-2.872a.732.732 0 000-.932zM29 38.512c-5.245 0-9.512-4.267-9.512-9.512s4.267-9.512 9.512-9.512 9.512 4.267 9.512 9.512-4.267 9.512-9.512 9.512z"
            })
        ]
    });
}
/* harmony default export */ var filtersQualifyLeadsIcon = (FiltersQualifyLeadsIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/privacySecurityIcon.tsx


function PrivacySecurityIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M36.89 25.327h-.238v-2.685c0-4.22-3.447-7.642-7.667-7.642s-7.666 3.422-7.666 7.612v2.685h-.238c-1.843 0-3.269 1.593-3.06 3.393l1.307 11.566A3.08 3.08 0 0022.388 43h13.254c1.575 0 2.912-1.18 3.06-2.744L39.98 28.72c.208-1.83-1.248-3.393-3.09-3.393zm-6.954 8.88l.387 3.482a.739.739 0 01-.743.826h-1.13a.739.739 0 01-.742-.826l.386-3.481a2.283 2.283 0 01-1.367-2.095 2.313 2.313 0 012.318-2.302 2.313 2.313 0 012.318 2.302c-.06.944-.624 1.74-1.427 2.095zm2.823-8.88h-7.548v-2.685c0-2.066 1.694-3.747 3.774-3.747s3.774 1.681 3.774 3.747v2.685z"
            })
        ]
    });
}
/* harmony default export */ var privacySecurityIcon = (PrivacySecurityIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/specialistsEachCategoryIcon.tsx


function SpecialistsEachCategoryIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M12.14 43.122h8.521v-8.505h-3.51V27.33h10.365v3.467h-3.52v8.505h8.52v-8.505h-3.483l-.01-3.467h10.365v7.287h-3.536v8.505h8.52v-8.505H40.89v-8.912H29.023v-4.2h3.507V13h-8.52v8.505h3.506v4.2H15.65v8.912h-3.51v8.505z"
            })
        ]
    });
}
/* harmony default export */ var specialistsEachCategoryIcon = (SpecialistsEachCategoryIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/icons/specializeInSemIcon.tsx


const SpecializeInSEMIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "57",
        fill: "none",
        viewBox: "0 0 57 57",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "57",
                height: "57",
                fill: "#EF4F80",
                rx: "10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2952_6925)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        fillRule: "evenodd",
                        d: "M41.23 45c-.997 0-1.9-.398-2.52-1.126L29.657 33.22c-.319-.375.22-.855.554-.538 1.477-1.188 2.158-2.052 2.449-2.497-.27-.336.196-.838.56-.529l10.653 9.056c2.366 2.01.797 6.286-2.642 6.286",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        fillRule: "evenodd",
                        d: "M23.643 35.288C17.209 35.288 12 30.078 12 23.645s5.21-11.643 11.643-11.643 11.643 5.209 11.643 11.643-5.209 11.643-11.643 11.643",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        fillRule: "evenodd",
                        d: "M23.641 13.352c-9.148 0-13.745 11.104-7.278 17.57 6.469 6.468 17.57 1.868 17.57-7.278a10.29 10.29 0 0 0-10.292-10.292",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EF4F80",
                        fillOpacity: "0.24",
                        d: "M33.684 23.645c0-5.55-4.493-10.043-10.043-10.043-8.925 0-13.41 10.834-7.1 17.143h-.001c6.311 6.31 17.144 1.822 17.144-7.1m.5 0c0 9.367-11.371 14.08-17.998 7.454-6.623-6.624-1.916-17.997 7.455-17.997a10.54 10.54 0 0 1 10.543 10.543"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EF4F80",
                        fillRule: "evenodd",
                        d: "M23.644 32.587c-4.93 0-8.94-4.011-8.94-8.942 0-.509.773-.509.773 0 0 4.504 3.664 8.168 8.168 8.168.509 0 .508.774 0 .774M32.198 24.031a.387.387 0 0 1-.387-.386c0-4.504-3.664-8.168-8.167-8.168-.51 0-.51-.774 0-.774 4.93 0 8.94 4.011 8.94 8.941a.386.386 0 0 1-.386.387M24.354 26.161H22.21a.387.387 0 0 1-.387-.386v-4.26c0-.213.173-.386.387-.386h2.143c.51 0 .509.773 0 .773h-1.756v3.486h1.756c.509 0 .51.773 0 .773",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EF4F80",
                        fillRule: "evenodd",
                        d: "M24.114 24.031H22.21c-.51 0-.51-.773 0-.773h1.904c.51 0 .51.773 0 .773M29.475 26.146a.387.387 0 0 1-.387-.386v-3.185c-1.156 1.35-.924 1.349-2.08 0v3.185c0 .509-.773.509-.773 0v-4.23c0-.359.447-.523.68-.252l1.133 1.322 1.134-1.322a.387.387 0 0 1 .68.252v4.23a.387.387 0 0 1-.387.386M18.877 26.161c-.905 0-1.699-.948-1.119-1.272.514-.286.476.499 1.12.499a.68.68 0 0 0 .677-.678c0-1.182-2.13-.184-2.13-2.13 0-1.61 2.248-2.004 2.81-.51.18.476-.544.748-.723.272-.262-.697-1.313-.514-1.313.239 0 1.182 2.13.184 2.13 2.129 0 .8-.652 1.451-1.452 1.451",
                        clipRule: "evenodd"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2952_6925",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M12 12h33v33H12z"
                    })
                })
            })
        ]
    });
/* harmony default export */ var specializeInSemIcon = (SpecializeInSEMIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/ourValuesPage/secondSection/index.tsx

















const secondSection_list = [
    {
        title: "We're Experts in Multiple Markets",
        p: "We work across legal, B2B, auto, home services, and consumer technology, with additional experience in financial products and other B2C categories. Our vertical specialists tailor each campaign to the dynamics of that specific market.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(expertsMultipleMarketsIcon, {})
    },
    {
        title: "We Speak Several Languages",
        p: "We build campaigns with translated landing pages and geo-targeted messaging, not just translated ad copy, so language differences don't stand between you and the audience you're trying to reach.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(speakSeveralLanguagesIcon, {})
    },
    {
        title: "Collaboration",
        p: "We stay in regular contact with the businesses we work with, keeping you updated on campaigns, answering questions, and solving problems together.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(collaborationIcon, {})
    },
    {
        title: "Flexibility",
        p: "Our agreements allow cancellation with just 48 hours' notice, no long-term lock-in required. We tailor the pricing model to what makes sense for your goals, rather than forcing every partner into the same structure.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(flexibilityIcon, {})
    },
    {
        title: "Account-Based Marketing (ABM)",
        p: "We focus on real, ideal-fit customers, not vague personas, using tools like hyper-personalized LinkedIn outreach and IP-based targeting rather than broad contact lists. Thorough research helps us reach people actively seeking our partners' products or services, which means better-fit leads, not just more of them.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(accountBasedMarketingIcon, {})
    },
    {
        title: "Performance-Based Pricing Model",
        p: "We offer performance-based pricing, including cost-per-lead, cost-per-call, and cost-per-click, plus other models tailored to your goals. You only pay when we deliver against agreed milestones, which keeps our incentives aligned with yours.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(performanceBasedPricingModelIcon, {})
    },
    {
        title: "Dedicated Account Manager",
        p: "Each partner gets a dedicated account manager as their main point of contact, with biweekly check-ins covering campaign progress, performance data, and any adjustments needed to stay aligned with your goals.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dedicatedAccountManagerIcon, {})
    },
    {
        title: "Cutting-Edge Technology",
        p: "Whether you're looking to generate more leads or improve existing campaigns, our machine-learning-powered technology helps identify patterns and optimize campaigns efficiently, supporting sustainable growth over time.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(cuttingEdgeTechnologyIcon, {})
    },
    {
        title: "Lead Verification Filters",
        p: "Every lead goes through automated checks and human review: filtering fraudulent submissions, running syntax checks, matching phone numbers to names and addresses, flagging duplicates, and checking for suspicious IP addresses. Anything that doesn't clear these checks gets held for review before it reaches you.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(filtersQualifyLeadsIcon, {})
    },
    {
        title: "Several Digital Marketing Tools",
        p: "We work across a range of channels, social media, search engines like Google, Bing, and Yahoo, dedicated landing pages, and review and comparison sites, choosing the mix that fits where your audience actually is.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(severalDigitalMarketingIcon, {})
    },
    {
        title: "Privacy & Security",
        htmlP: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "We comply with TCPA and CCPA/CPRA regulations, and every lead comes with TrustedForm and Jornaya ID verification. You can review the full details in our",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://severalbrands.com/privacy-policy",
                    className: "text-[#EF4F80] hover:underline",
                    children: "Privacy Policy"
                }),
                "."
            ]
        }),
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(privacySecurityIcon, {})
    },
    {
        title: "Specialists in Each Category",
        p: "Behind every campaign is a team with real depth, engineers, marketers, social media specialists, and content writers who understand their categories in detail. That range of expertise is how we target the right audience effectively and translate that into leads that convert.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(specialistsEachCategoryIcon, {})
    },
    {
        title: "We Specialize in SEM",
        p: "With over 100 landing pages, we know how to target the right audience with the right keywords, driving traffic that converts into real business for our partners. We rank well across both organic and paid search.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(specializeInSemIcon, {})
    }, 
];
function SecondSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: `${(style_module_default()).bgStyle} px-4 lg:px-0 mt-10 lg:mt-0  `,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "py-20 lg:py-52",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                    transition: {
                        duration: 1.5
                    },
                    initial: {
                        opacity: 0,
                        y: 150
                    },
                    whileInView: {
                        opacity: 1,
                        y: 0
                    },
                    viewport: {
                        once: true
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-bold text-[#37367D] 3xl:text-7xl 3xl:leading-[4.5rem] lg:text-5xl lg:leading-[3.5rem] text-3xl leading-10 ",
                            children: "Values in Action"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-[#EF4F80] 3xl:text-3xl 3xl:leading-[3.5rem] lg:text-xl text-lg lg:leading-10 3xl:mt-3 mt-1",
                            children: "Where Ideas Meet Execution"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mt-5 3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 3xl:max-w-[1027px] lg:max-w-[827px] font-light",
                            children: "From search visibility to lead verification and everything in between, here's a closer look at how our values show up in the way we actually work."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: `flex  flex-wrap  mt-16 3xl:gap-[160px] lg:gap-[110px] gap-[60px]`,
                    children: secondSection_list.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MainSharedComponent, {
                            title: el.title,
                            description: el.p,
                            htmlDescription: el.htmlP,
                            icon: el.icon
                        }, index))
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/metaTags/index.tsx
var severalbrands_metaTags = __webpack_require__(66405);
// EXTERNAL MODULE: ./src/components/severalbrands/utils/index.ts
var utils = __webpack_require__(54531);
;// CONCATENATED MODULE: ./pages/severalbrands/our-values.tsx







var __N_SSG = true;
function SeveralBrandsHome({ domain  }) {
    const metaTags = (0,utils/* getMetaTitleDescriptionForPage */.Z5)(domain, "OurValues");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(severalBrandsWrapper/* default */.Z, {
        domainInfo: domain,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(severalbrands_metaTags/* default */.Z, {
                title: metaTags?.title ?? "Our Values | SeveralBrands.com",
                description: metaTags?.description ?? "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.",
                keyWords: (0,utils/* getKeyWordsForMetaTags */.U8)(domain)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondSection, {})
        ]
    });
}


/***/ }),

/***/ 54531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ getUrl; },
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "U8": function() { return /* binding */ getKeyWordsForMetaTags; },
/* harmony export */   "Z5": function() { return /* binding */ getMetaTitleDescriptionForPage; },
/* harmony export */   "_7": function() { return /* binding */ getDescriptionForPostByID; },
/* harmony export */   "_H": function() { return /* binding */ getMainTitlesNavigationFromBody; },
/* harmony export */   "fH": function() { return /* binding */ getFinalLogosForLogoSLider; },
/* harmony export */   "fx": function() { return /* binding */ getDescriptionForHomePage; },
/* harmony export */   "nn": function() { return /* binding */ addStyleClassToIframe; },
/* harmony export */   "qp": function() { return /* binding */ getKeyWordsForPostByID; },
/* harmony export */   "yV": function() { return /* binding */ addStyleClassToTable; }
/* harmony export */ });
/* unused harmony export extractExcerptFromBody */
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75094);

const getUrl = (pathname = "")=>{
    return `${window.location.origin}${pathname}`;
};
const getMainTitlesNavigationFromBody = (html)=>{
    const regex = /<[^>]+ id="([^"]+)"[^>]*>([\s\S]+?)<\/[^>]+>/g;
    const result = [];
    let match;
    while(match = regex.exec(html)){
        const [, id, content] = match;
        const textNodes = content.match(/>([^<]+)/g);
        if (textNodes) {
            result.push(// eslint-disable-next-line no-unsafe-optional-chaining
            ...textNodes?.map((node)=>({
                    value: node.substring(1).trim(),
                    id
                })));
        } else {
            result.push({
                value: content.trim(),
                id
            });
        }
    }
    return result.filter((i)=>i.value?.length > 1).map((el)=>({
            title: /^\d/.test(el.value) ? el.value.replace(/^\d/, "").slice(1) : el.value,
            link: `#${el.id}`
        }));
};
const addStyleClassToTable = (body)=>{
    if (body) {
        // start tag replace with <div className="table-responsive" > <table
        const firstSectionStartTag = body?.split("<table")[0]; // first section dose not contain <table to replace
        const bodyAfterReplaceStartTag = body?.split("<table").slice(1).map((table)=>{
            return `<div class="table-responsive"> <table ${table}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </table> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</table>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</table>").slice(1).map((table)=>{
            return `</table></div>${table}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const addStyleClassToIframe = (body)=>{
    if (body) {
        // start tag replace with <div className="iframe-responsive" > <iframe
        const firstSectionStartTag = body?.split("<iframe")[0]; // first section dose not contain <iframe to replace
        const bodyAfterReplaceStartTag = body?.split("<iframe").slice(1).map((iframe)=>{
            return `<div class="iframe-responsive"> <iframe ${iframe}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </iframe> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</iframe>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</iframe>").slice(1).map((iframe)=>{
            return `</iframe></div>${iframe}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const getFormattedDate = (date)=>{
    const regex = /^[0-9]+$/; //check if the string contain only numeric characters(time stamp)
    return new Date(regex.test(date) ? +date : date).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};
const extractExcerptFromBody = (body, characters)=>{
    return body.replace(/<[^>]+>/g, "").substring(0, characters).trim();
};
const getDescriptionForPostByID = (post)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post.metatags[i]?.key === "description" && post.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.excerpt) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.excerpt, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    if (post?.body) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.body, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForPostByID = (post, domainInfo)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post?.metatags[i]?.key === "keywords" && post?.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.tags) {
        return post?.tags?.map((tag)=>tag?.name).join(",");
    }
    for(let i1 = 0; i1 < (domainInfo?.metatags.length ?? 0); i1++){
        if (domainInfo?.metatags[i1]?.key === "keywords" && domainInfo?.metatags[i1]?.value) {
            return domainInfo?.metatags[i1]?.value;
        }
    }
    return "";
};
const getDescriptionForHomePage = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "extra-meta-HomePage-meta-description" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    if (domain?.description) {
        return domain.description.replace(/<[^>]+>/g, "");
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForMetaTags = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "keywords" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    return "";
};
const getMetaTitleDescriptionForPage = (domain, keyPage)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        return {
            title: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-title`)?.value,
            description: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-description`)?.value
        };
    }
};
const getFinalLogosForLogoSLider = (featuredList, categorySlug)=>{
    const finalLogos = featuredList ? categorySlug ? featuredList[categorySlug] : featuredList["default"] : [];
    return finalLogos;
};


/***/ }),

/***/ 96494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle___5xfW"};

/***/ }),

/***/ 50259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pm": function() { return /* binding */ h; },
/* harmony export */   "xX": function() { return /* binding */ g; }
/* harmony export */ });
/* unused harmony exports GoogleReCaptcha, GoogleReCaptchaConsumer, GoogleReCaptchaContext, withGoogleReCaptcha */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* provided dependency */ var process = __webpack_require__(83454);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var s=function(){return s=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},s.apply(this,arguments)};function u(e,t,r,o){return new(r||(r=Promise))((function(n,a){function c(e){try{s(o.next(e))}catch(e){a(e)}}function i(e){try{s(o.throw(e))}catch(e){a(e)}}function s(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(c,i)}s((o=o.apply(e,t||[])).next())}))}function l(e,t){var r,o,n,a,c={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return a={next:i(0),throw:i(1),return:i(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function i(a){return function(i){return function(a){if(r)throw new TypeError("Generator is already executing.");for(;c;)try{if(r=1,o&&(n=2&a[0]?o.return:a[0]?o.throw||((n=o.return)&&n.call(o),0):o.next)&&!(n=n.call(o,a[1])).done)return n;switch(o=0,n&&(a=[2&a[0],n.value]),a[0]){case 0:case 1:n=a;break;case 4:return c.label++,{value:a[1],done:!1};case 5:c.label++,o=a[1],a=[0];continue;case 7:a=c.ops.pop(),c.trys.pop();continue;default:if(!(n=c.trys,(n=n.length>0&&n[n.length-1])||6!==a[0]&&2!==a[0])){c=0;continue}if(3===a[0]&&(!n||a[1]>n[0]&&a[1]<n[3])){c.label=a[1];break}if(6===a[0]&&c.label<n[1]){c.label=n[1],n=a;break}if(n&&c.label<n[2]){c.label=n[2],c.ops.push(a);break}n[2]&&c.ops.pop(),c.trys.pop();continue}a=t.call(e,c)}catch(e){a=[6,e],o=0}finally{r=n=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,i])}}}var f,p=function(e){var t;e?function(e){if(e)for(;e.lastChild;)e.lastChild.remove()}("string"==typeof e?document.getElementById(e):e):(t=document.querySelector(".grecaptcha-badge"))&&t.parentNode&&document.body.removeChild(t.parentNode)},d=function(e,t){p(t),window.___grecaptcha_cfg=void 0;var r=document.querySelector("#"+e);r&&r.remove(),function(){var e=document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');e&&e.remove()}()},y=function(e){var t=e.render,r=e.onLoadCallbackName,o=e.language,n=e.onLoad,a=e.useRecaptchaNet,c=e.useEnterprise,i=e.scriptProps,s=void 0===i?{}:i,u=s.nonce,l=void 0===u?"":u,f=s.defer,p=void 0!==f&&f,d=s.async,y=void 0!==d&&d,m=s.id,v=void 0===m?"":m,b=s.appendTo,h=v||"google-recaptcha-v3";if(function(e){return!!document.querySelector("#"+e)}(h))n();else{var g=function(e){return"https://www."+(e.useRecaptchaNet?"recaptcha.net":"google.com")+"/recaptcha/"+(e.useEnterprise?"enterprise.js":"api.js")}({useEnterprise:c,useRecaptchaNet:a}),S=document.createElement("script");S.id=h,S.src=g+"?render="+t+("explicit"===t?"&onload="+r:"")+(o?"&hl="+o:""),l&&(S.nonce=l),S.defer=!!p,S.async=!!y,S.onload=n,("body"===b?document.body:document.getElementsByTagName("head")[0]).appendChild(S)}},m=function(e){"undefined"!=typeof process&&!!process.env&&"production"!=="production"||console.warn(e)};!function(e){e.SCRIPT_NOT_AVAILABLE="Recaptcha script is not available"}(f||(f={}));var v=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({executeRecaptcha:function(){throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider")}}),b=v.Consumer;function h(t){var i=t.reCaptchaKey,u=t.useEnterprise,l=void 0!==u&&u,p=t.useRecaptchaNet,b=void 0!==p&&p,h=t.scriptProps,g=t.language,S=t.container,w=t.children,$=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),C=$[0],P=$[1],x=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(i),E=JSON.stringify(h),R=JSON.stringify(null==S?void 0:S.parameters);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((function(){if(i){var e=(null==h?void 0:h.id)||"google-recaptcha-v3",t=(null==h?void 0:h.onLoadCallbackName)||"onRecaptchaLoadCallback";window[t]=function(){var e=l?window.grecaptcha.enterprise:window.grecaptcha,t=s({badge:"inline",size:"invisible",sitekey:i},(null==S?void 0:S.parameters)||{});x.current=e.render(null==S?void 0:S.element,t)};return y({render:(null==S?void 0:S.element)?"explicit":i,onLoadCallbackName:t,useEnterprise:l,useRecaptchaNet:b,scriptProps:h,language:g,onLoad:function(){if(window&&window.grecaptcha){var e=l?window.grecaptcha.enterprise:window.grecaptcha;e.ready((function(){P(e)}))}else m("<GoogleRecaptchaProvider /> "+f.SCRIPT_NOT_AVAILABLE)},onError:function(){m("Error loading google recaptcha script")}}),function(){d(e,null==S?void 0:S.element)}}m("<GoogleReCaptchaProvider /> recaptcha key not provided")}),[l,b,E,R,g,i,null==S?void 0:S.element]);var M=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((function(e){if(!C||!C.execute)throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");return C.execute(x.current,{action:e})}),[C,x]),N=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)((function(){return{executeRecaptcha:C?M:void 0,container:null==S?void 0:S.element}}),[M,C,null==S?void 0:S.element]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(v.Provider,{value:N},w)}var g=function(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(v)};function S(t){var r=this,o=t.action,a=t.onVerify,c=t.refreshReCaptcha,i=g();n((function(){var e=i.executeRecaptcha;if(e){u(r,void 0,void 0,(function(){var t;return l(this,(function(r){switch(r.label){case 0:return[4,e(o)];case 1:return t=r.sent(),a?(a(t),[2]):(m("Please define an onVerify function"),[2])}}))}))}}),[o,a,c,i]);var s=i.container;return"string"==typeof s?e.createElement("div",{id:s}):null}function w(e,t){return e(t={exports:{}},t.exports),t.exports
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */}var $="function"==typeof Symbol&&Symbol.for,C=$?Symbol.for("react.element"):60103,P=$?Symbol.for("react.portal"):60106,x=$?Symbol.for("react.fragment"):60107,E=$?Symbol.for("react.strict_mode"):60108,R=$?Symbol.for("react.profiler"):60114,M=$?Symbol.for("react.provider"):60109,N=$?Symbol.for("react.context"):60110,O=$?Symbol.for("react.async_mode"):60111,_=$?Symbol.for("react.concurrent_mode"):60111,T=$?Symbol.for("react.forward_ref"):60112,j=$?Symbol.for("react.suspense"):60113,L=$?Symbol.for("react.suspense_list"):60120,k=$?Symbol.for("react.memo"):60115,F=$?Symbol.for("react.lazy"):60116,A=$?Symbol.for("react.block"):60121,V=$?Symbol.for("react.fundamental"):60117,z=$?Symbol.for("react.responder"):60118,G=$?Symbol.for("react.scope"):60119;function I(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case C:switch(e=e.type){case O:case _:case x:case R:case E:case j:return e;default:switch(e=e&&e.$$typeof){case N:case T:case F:case k:case M:return e;default:return t}}case P:return t}}}function D(e){return I(e)===_}var q={AsyncMode:O,ConcurrentMode:_,ContextConsumer:N,ContextProvider:M,Element:C,ForwardRef:T,Fragment:x,Lazy:F,Memo:k,Portal:P,Profiler:R,StrictMode:E,Suspense:j,isAsyncMode:function(e){return D(e)||I(e)===O},isConcurrentMode:D,isContextConsumer:function(e){return I(e)===N},isContextProvider:function(e){return I(e)===M},isElement:function(e){return"object"==typeof e&&null!==e&&e.$$typeof===C},isForwardRef:function(e){return I(e)===T},isFragment:function(e){return I(e)===x},isLazy:function(e){return I(e)===F},isMemo:function(e){return I(e)===k},isPortal:function(e){return I(e)===P},isProfiler:function(e){return I(e)===R},isStrictMode:function(e){return I(e)===E},isSuspense:function(e){return I(e)===j},isValidElementType:function(e){return"string"==typeof e||"function"==typeof e||e===x||e===_||e===R||e===E||e===j||e===L||"object"==typeof e&&null!==e&&(e.$$typeof===F||e.$$typeof===k||e.$$typeof===M||e.$$typeof===N||e.$$typeof===T||e.$$typeof===V||e.$$typeof===z||e.$$typeof===G||e.$$typeof===A)},typeOf:I},B=w((function(e,t){ false&&0})),J=(B.AsyncMode,B.ConcurrentMode,B.ContextConsumer,B.ContextProvider,B.Element,B.ForwardRef,B.Fragment,B.Lazy,B.Memo,B.Portal,B.Profiler,B.StrictMode,B.Suspense,B.isAsyncMode,B.isConcurrentMode,B.isContextConsumer,B.isContextProvider,B.isElement,B.isForwardRef,B.isFragment,B.isLazy,B.isMemo,B.isPortal,B.isProfiler,B.isStrictMode,B.isSuspense,B.isValidElementType,B.typeOf,w((function(e){ true?e.exports=q:0}))),K={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},U={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},H={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},Q={};function W(e){return J.isMemo(e)?H:Q[e.$$typeof]||K}Q[J.ForwardRef]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},Q[J.Memo]=H;var X=Object.defineProperty,Y=Object.getOwnPropertyNames,Z=Object.getOwnPropertySymbols,ee=Object.getOwnPropertyDescriptor,te=Object.getPrototypeOf,re=Object.prototype;var oe=function e(t,r,o){if("string"!=typeof r){if(re){var n=te(r);n&&n!==re&&e(t,n,o)}var a=Y(r);Z&&(a=a.concat(Z(r)));for(var c=W(t),i=W(r),s=0;s<a.length;++s){var u=a[s];if(!(U[u]||o&&o[u]||i&&i[u]||c&&c[u])){var l=ee(r,u);try{X(t,u,l)}catch(e){}}}}return t},ne=function(t){var r=function(r){return e.createElement(b,null,(function(o){return e.createElement(t,s({},r,{googleReCaptchaProps:o}))}))};return r.displayName="withGoogleReCaptcha("+(t.displayName||t.name||"Component")+")",oe(r,t),r};
//# sourceMappingURL=react-google-recaptcha-v3.esm.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [11943,81711,49774,92888,40179], function() { return __webpack_exec__(95414); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);